/* Segmented toggle: adds an iOS-style sliding thumb to a pill toggle.

   Mark the toggle with [data-segmented]; its direct-child buttons are the
   segments and the one with .is-active is the selected one. The component
   that owns the toggle keeps switching .is-active as before -- this only
   watches that class and glides the thumb to follow it, so it never
   changes what the tabs do. Styles: assets/segmented-toggle.css.

   Used by the homepage Shop by category section and the header Shop menu. */
(function () {
  function attach(toggle) {
    if (toggle.dataset.segmentedInit) return;
    toggle.dataset.segmentedInit = '1';

    var buttons = Array.prototype.slice.call(toggle.children).filter(function (el) {
      return el.tagName === 'BUTTON';
    });
    if (buttons.length < 2) return;

    var thumb = document.createElement('span');
    thumb.className = 'segmented-thumb';
    thumb.setAttribute('aria-hidden', 'true');
    toggle.insertBefore(thumb, toggle.firstChild);

    function place() {
      var active = buttons.filter(function (b) { return b.classList.contains('is-active'); })[0];
      if (!active || !active.offsetWidth) return false;
      thumb.style.width = active.offsetWidth + 'px';
      thumb.style.setProperty('--thumb-x', active.offsetLeft + 'px');
      return true;
    }

    // First placement happens without animation; the thumb only starts
    // gliding once it has been placed (the toggle may be hidden at load,
    // e.g. inside a closed dropdown, so keep trying until it has a size).
    function placeInitial() {
      if (!place()) return;
      toggle.setAttribute('data-segmented-ready', '');
      // Turn transitions on a frame later so the first placement doesn't animate
      setTimeout(function () { toggle.classList.add('segmented--animate'); }, 50);
    }

    placeInitial();

    if (window.ResizeObserver) {
      new ResizeObserver(function () {
        if (!toggle.hasAttribute('data-segmented-ready')) placeInitial();
        else place();
      }).observe(toggle);
    }
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(place);

    if (window.MutationObserver) {
      new MutationObserver(place).observe(toggle, { attributes: true, attributeFilter: ['class'], subtree: true });
    }

    // Press feedback: the thumb squeezes slightly while held on the active segment
    function release() { toggle.classList.remove('is-pressed'); }
    buttons.forEach(function (b) {
      b.addEventListener('pointerdown', function () {
        if (b.classList.contains('is-active')) toggle.classList.add('is-pressed');
      });
    });
    toggle.addEventListener('pointerup', release);
    toggle.addEventListener('pointerleave', release);
    toggle.addEventListener('pointercancel', release);
  }

  function attachAll(root) {
    Array.prototype.slice.call((root || document).querySelectorAll('[data-segmented]')).forEach(attach);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { attachAll(); });
  else attachAll();
  document.addEventListener('shopify:section:load', function (e) { attachAll(e.target); });
})();
